import React, { useEffect, useState, useMemo } from "react";
import { Card, CardBody, Col, Container, Row, Input, Label, CardHeader } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import TabelaEspacosRota from "./consulta";
import { api } from "../../../config";
import Loader from "../../../Components/Common/Loader";
import { fetchComAuth, fetchComAuthJson } from "../../../common/api"; 
import { toast } from 'react-toastify';
import { ToastContainer } from "react-toastify";

const STORAGE_KEY = "last_feira_selecionada_espacos";

const ListaEspacosRota = ({ feiraId: propFeiraId }) => {
  const [dados, setDados] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
  const authUser = useMemo(() => JSON.parse(sessionStorage.getItem("authUser")) || {}, []);
  const userData = authUser.user || authUser;
  
  const feirasOptions = useMemo(() => {
    return userData.feiras?.map(f => ({
      value: f.feira_id.toString(),
      label: f.feira?.nome || `Feira ${f.feira_id}`
    })) || [];
  }, [userData]);

  const [feiraSelecionada, setFeiraSelecionada] = useState(() => {
    // 1. Se vier via prop (cadastro de feiras), usa a prop
    if (propFeiraId) return propFeiraId;

    // 2. Se houver apenas uma feira disponível, seleciona ela por padrão
    if (feirasOptions.length === 1) return feirasOptions[0].value;

    // 3. Tenta recuperar a última feira gravada no localStorage
    const salva = localStorage.getItem(STORAGE_KEY);
    // Verifica se a feira salva ainda está na lista de feiras permitidas do usuário
    if (salva && feirasOptions.some(f => f.value === salva)) {
      return salva;
    }

    return "";
  });

  const fetchDados = async (id) => {
    
    if (!id) return;
    setIsLoading(true);
    try {
      const response = await fetchComAuth(`${api.API_URL}/rota/estandes/${id}?refresh=1`, {
        method: 'GET'
      });
      
      const json = await response.json();
      
      if (!response.ok) throw new Error("Erro ao buscar os dados");
      
      setDados(json.data || []);
      setError(null);
    } catch (error) {
      setError(error.message);
      setDados([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFeiraChange = (val) => {
    setFeiraSelecionada(val);
    if (!propFeiraId) { // Só grava se estiver no módulo independente
        localStorage.setItem(STORAGE_KEY, val);
    }
  };

  useEffect(() => {
    if (feiraSelecionada) {
      fetchDados(feiraSelecionada);
    }
  }, [feiraSelecionada]);

  const handleDeleteSpace = async (id) => {
    try {
      const response = await fetchComAuthJson(`${api.API_URL}/rota/estande/${id}`, {
        method: 'DELETE'
      });
      
      if (response.ok) {
        toast.success("Espaço excluído com sucesso!");
        setDados(prev => prev.filter(item => item.id !== id));
      } else {
        toast.error("Erro ao excluir o espaço.");
      }
    } catch (e) {
      toast.error("Erro de comunicação com o servidor.");
    }
  };

  return (
    <div className={!propFeiraId ? "page-content" : ""}>
      
      {!propFeiraId && (<ToastContainer closeButton={false} />)}

      <Container fluid>
        {!propFeiraId && <BreadCrumb title="Lista de Espaços" pageTitle="Processos" />}
        
        <Row>
          <Col lg={12}>
            <Card>
              {/* O Select só aparece se NÃO estivermos dentro do cadastro de uma feira específica */}
              {!propFeiraId && (
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <Col md={4}>
                      <Label className="form-label">Selecione a Feira</Label>
                      
                      <Input 
                        type="select" 
                        value={feiraSelecionada} 
                        onChange={(e) => handleFeiraChange(e.target.value)} // Alterado para handleFeiraChange
                      >
                        <option value="">Selecione uma feira...</option>
                        {feirasOptions.map(f => (
                          <option key={f.value} value={f.value}>{f.label}</option>
                        ))}
                      </Input>
                    </Col>
                  </Row>
                </CardHeader>
              )}
              
              <CardBody>
                {!feiraSelecionada ? (
                  <div className="text-center py-5">
                    <i className="ri-building-2-line fs-1 text-muted"></i>
                    <h5 className="mt-3">Nenhuma feira selecionada</h5>
                    <p className="text-muted">Escolha uma feira no seletor acima para visualizar os espaços.</p>
                  </div>
                ) : isLoading ? (
                  <Loader />
                ) : error ? (
                  <Loader error={error} />
                ) : (
                  <TabelaEspacosRota
                    data={dados} 
                    onDelete={handleDeleteSpace} 
                    feiraId={feiraSelecionada} 
                    isFeiraContext={!!propFeiraId}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ListaEspacosRota;